var _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1111,
    height: 1111,
    viewBox: "0 0 1111 1111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    filter: "url(#filter0_f_1877_15335)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 555.5,
    cy: 555.5,
    r: 287.5,
    fill: "#1D4CA7",
    fillOpacity: 0.25
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1877_15335",
    x: 0.399994,
    y: 0.399994,
    width: 1110.2,
    height: 1110.2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 133.8,
    result: "effect1_foregroundBlur_1877_15335"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlowLeft);
export default __webpack_public_path__ + "static/media/GlowLeft.afe9d5af49c092b7bdca1ed36c91a524.svg";
export { ForwardRef as ReactComponent };